import { colors } from '@/theme/colors.theme'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(() => {
  return {
    tabsSidebar: {
      height: 'auto',
      minHeight: 'calc(100vh - 100px)',
      position: 'relative',
      overflow: 'hidden',
      minWidth: '385px',
      padding: '0px 65px',

      '& .MuiDialog-paperFullWidth': {
        width: '800px',
        maxWidth: '100%',
      },
    },

    tabs: {
      display: 'block',
      '& .MuiTabs-flexContainer': {
        flexDirection: 'column',
        display: 'flex',
      },
      '& .MuiTabs-indicator': {
        display: 'none', // Esto oculta el indicador de pestaña
      },
      '& .tab-icon': {
        display: 'flex',
        flexDirection: 'row',
        margin: 0,
        width: '100%',
        justifyContent: 'left',
        padding: '15px 0px',
        whiteSpace: 'nowrap',
      },
      '& .tab-bullet': {
        fontSize: '16px',
        border: '2px solid',
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        marginRight: '16px',
        lineHeight: '25px',
      },
    },

    children: {
      display: 'flex',
      justifyContent: 'end',
      width: '100%',
      background: colors.nav,
      position: 'relative',
      overflow: 'hidden',
    },
  }
})
